import React from "react";
import RichTextField from "components/Contentful/RichTextField";
import PropTypes from "prop-types";
import styled from "styled-components";
import Collapsible from "components/Collapsible";

const CollapsibleWrapper = styled.section`
  margin: 0 auto;
  max-width: 48.75rem;
  padding: 0 1rem 6rem;
  width: 100%;

  :last-of-type {
    margin: 0 auto 2rem;
  }

  > div {
    border-bottom: 0.0625rem solid
      ${({ theme }) => theme.themeColors.darkGreen3};
  }

  button {
    height: auto;
    padding: 1.5rem 0;
    text-align: left;

    h4 {
      font-size: 1.5rem;
      height: auto;
      line-height: 1.3125;
    }

    svg {
      fill: ${({ theme }) => theme.themeColors.orange1};
      height: 1.625rem;
      width: 1.625rem;
    }
  }

  section {
    padding: 0;

    &.open {
      padding: 0.5rem 0 1.5rem;
    }

    h4 {
      font-size: 1.125rem;
    }

    ul {
      margin: 0 0 2rem;
      padding: 0 0 0 1rem;

      :last-of-type,
      li:last-of-type {
        margin: 0;
      }

      li {
        color: ${({ theme }) => theme.themeColors.darkGreen4};
        line-height: 1.3125;

        &::marker {
          color: ${({ theme }) => theme.themeColors.orange1};
        }
      }
    }
  }
`;

const CollapsibleTitle = styled.h3`
  text-align: center;
  font-size: 2.375rem;
  margin: 3.75rem auto 1rem;

  ${({ theme }) => theme.mq.lg`
    font-size: 3rem;
    margin: 4.375rem auto 1rem;
  `};
`;
function CollapsibleBlock({ blockData }) {
  const title = blockData?.title;
  const collapsibleItems = blockData?.collapsibleItems;
  return (
    <>
      <CollapsibleWrapper>
        <CollapsibleTitle>{title}</CollapsibleTitle>
        {collapsibleItems?.map((item) => {
          const itemTitle = item?.fields?.itemTitle;
          const itemContent = item?.fields?.itemContent;
          return (
            <Collapsible
              title={itemTitle}
              headerBackground="white"
              key={itemTitle}
            >
              <RichTextField richText={itemContent} />
            </Collapsible>
          );
        })}
      </CollapsibleWrapper>
    </>
  );
}

export default CollapsibleBlock;

CollapsibleBlock.propTypes = {
  blockData: PropTypes.oneOfType({
    title: PropTypes.string,
    collapsibleItems: PropTypes.object,
  }),
};

CollapsibleBlock.defaultProps = {
  blockData: {
    title: "",
    collapsibleItems: {},
  },
};
